import React from 'react';
import { Spinner, BlockStack } from '@shopify/polaris';

// Shared full-page loading spinner - replaces the ~6 duplicated
// `<div style={{textAlign:'center', padding:...}}><Spinner/></div>` blocks.
const LoadingState = ({ label = 'Loading' }) => (
  <BlockStack inlineAlign="center">
    <div style={{ padding: 'var(--p-space-2000)' }}>
      <Spinner size="large" accessibilityLabel={label} />
    </div>
  </BlockStack>
);

export default LoadingState;
